import api from "../services/api"

const getSavedLeadFilters = async scope => {
    const response = await api.get("/saved-lead-filters", { params: { scope } })
    return response.data?.data || []
}

const createSavedLeadFilter = async data => {
    const response = await api.post("/saved-lead-filters", data)
    return response.data?.data
}

const updateSavedLeadFilter = async (filterId, data) => {
    const response = await api.patch(`/saved-lead-filters/${filterId}`, data)
    return response.data?.data
}

const deleteSavedLeadFilter = async filterId => {
    await api.delete(`/saved-lead-filters/${filterId}`)
}

export { createSavedLeadFilter, deleteSavedLeadFilter, getSavedLeadFilters, updateSavedLeadFilter }
